(() => {
  const product = 50519107141867;
  const services = [50519289495787, 50519289561323];
  const root = () => window.Shopify?.routes?.root || '/';
  const plan = cart => {
    const count = cart.items.filter(i => i.variant_id === product).reduce((n, i) => n + i.quantity, 0);
    const updates = {};
    services.forEach(id => cart.items.filter(i => i.variant_id === id).forEach((item, index) => {
      const wanted = count && index === 0 ? 1 : 0;
      if (item.quantity !== wanted) updates[item.key] = wanted;
    }));
    const wantedCode = cart.currency === 'USD' && count >= 2 ? `MLCAL${count >= 10 ? 10 : count >= 3 ? 3 : 2}` : '';
    const oldCodes = (cart.discount_codes || []).map(d => d.code);
    const codes = oldCodes.filter(code => !/^MLCAL(2|3|10)$/i.test(code));
    if (wantedCode) codes.push(wantedCode);
    return { updates, discount: codes.join(','), changed: Object.keys(updates).length > 0 || oldCodes.map(c => c.toUpperCase()).sort().join(',') !== codes.map(c => c.toUpperCase()).sort().join(',') };
  };
  const request = async (path, body) => {
    const response = await fetch(root() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to verify your cart. Please refresh and try again.');
    const data = await response.json();
    if (data.errors || data.status) throw new Error(data.description || 'Unable to update your cart.');
    return data;
  };
  window.MirthloomCalendarCart = {
    plan,
    async normalize(cart, sections) {
      cart ||= await request('cart.js');
      const change = plan(cart);
      if (!change.changed) return cart;
      return request('cart/update.js', { updates: change.updates, discount: change.discount, ...(sections ? { sections, sections_url: location.pathname } : {}) });
    }
  };
  // Verify before checkout, including carts restored from a previous visit.
  let checking = false;
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[name="checkout"],a[href$="/checkout"]');
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    const wasDisabled = checkout.disabled;
    checkout.disabled = true;
    try {
      if (window.mirthloomCartPending) throw new Error('Your cart is still updating. Please wait a moment and try again.');
      await window.MirthloomCalendarCart.normalize();
      location.assign(root() + 'checkout');
    } catch (error) {
      alert(error.message);
      checkout.disabled = wasDisabled;
      checking = false;
    }
  }, true);
})();
